<template>
  <a v-if="isUrl" :href="action" v-bind="{ target }">
    <slot />
  </a>
  <button v-else @click="doAction">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    isUrl() {
      // All we need to do currently is distinguish between urls and page actions such as
      // 'showWizardForm', hence this extremely simplified test.
      return this.action && (this.action.includes('/') || this.action.startsWith('#'))
    },
    target() {
      if (this.action) {
        if (/^https?:\/\/(?!inseego\.com)/.test(this.action)) {
          // Action is a url linking to a non-inseego.com address, so open in new tab.
          return '_blank'
        }
      }
    },
  },
  methods: {
    doAction(event) {
      if (this.$attrs.onClick) {
        this.$attrs.onClick(event)
      }
      else if (this.action) {
        this.$pageActions.dispatch(this.action, this.text);
      }
    }
  },
}
</script>
